// extracted by mini-css-extract-plugin
export var author = "BlogLatestSection-module--author--98afb";
export var backgroundImage = "BlogLatestSection-module--backgroundImage--b09be";
export var btn = "BlogLatestSection-module--btn--66537";
export var date = "BlogLatestSection-module--date--2aea8";
export var excerpt = "BlogLatestSection-module--excerpt--32525";
export var filterCategory = "BlogLatestSection-module--filterCategory--25463";
export var filterSelector = "BlogLatestSection-module--filterSelector--ade52";
export var filters = "BlogLatestSection-module--filters--4a8bb";
export var filtersGrid = "BlogLatestSection-module--filtersGrid--4a523";
export var header = "BlogLatestSection-module--header--2f976";
export var headerWrapper = "BlogLatestSection-module--headerWrapper--64358";
export var heading = "BlogLatestSection-module--heading--45cb2";
export var postItemCode = "BlogLatestSection-module--postItemCode--35829";
export var postItemConsulting = "BlogLatestSection-module--postItemConsulting--39224";
export var postItemContent = "BlogLatestSection-module--postItemContent--316c1";
export var postItemEducation = "BlogLatestSection-module--postItemEducation--d4f99";
export var postItemWrapper = "BlogLatestSection-module--postItemWrapper--429bd";
export var postList = "BlogLatestSection-module--postList--f46a7";
export var searchField = "BlogLatestSection-module--searchField--0c3cd";
export var searchFieldWrapper = "BlogLatestSection-module--searchFieldWrapper--5999c";
export var tag = "BlogLatestSection-module--tag--ab2a6";
export var tagList = "BlogLatestSection-module--tagList--86c28";
export var title = "BlogLatestSection-module--title--cfd03";
export var titleWrapper = "BlogLatestSection-module--titleWrapper--d1012";
export var wrapper = "BlogLatestSection-module--wrapper--4c994";